import React from "react";
import { useNavigate } from "react-router-dom";
import WorkflowTimeline from "./WorkflowTimeline";
import "./TitlePage.css";

function TitlePage() {
  const navigate = useNavigate();

  const handleWeiter = () => {
    navigate("/survey");
  };

  return (
    <div className="title-container">
      <header className="title-header">
        <h1>Hausarztpraxis am Schlossberg</h1>
        <h2>Dr. Langer &amp; Dr. Tausch</h2>
      </header>
      <section className="info-section">
        <h3>Warum diese Anwendung?</h3>
        <p>
          Diese Anwendung ist Teil einer Bachelorarbeit, die das Verhalten von
          Patienten im Wartezimmer analysiert. Ziel ist es, herauszufinden, wie
          die Wartezeit angenehmer gestaltet werden kann. Ihre Teilnahme hilft,
          wertvolle Erkenntnisse für die Praxisorganisation zu gewinnen.
        </p>
        <h3>Ablauf der Anwendung</h3>
        <WorkflowTimeline />
        <div className="critical-box">
          <p>
            WICHTIGER HINWEIS: Falls Sie das Spiel vorzeitig abbrechen, müssen
            Sie die Endumfrage vollständig abschließen, damit Ihre Daten erfasst
            werden.
          </p>
        </div>
      </section>
      <div className="button-container">
        <button className="weiter-button" onClick={handleWeiter}>
          Weiter
        </button>
      </div>
    </div>
  );
}

export default TitlePage;